<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div class="form-group col-span-12 xl:col-span-1">
      <label> URL: </label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="url" />
      </mat-form-field>
    </div>

    <div class="col-span-2">
      <label>{{ 'error' | translate }}: </label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="subject" rows="2"></textarea>
      </mat-form-field>
    </div>

    <div class="col-span-2">
      <label>{{ 'comment' | translate }}: </label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="text" rows="2"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions [align]="'end'">
    <button mat-button mat-dialog-close mat-stroked-button type="button">{{ 'actions.cancel' | translate }}</button>
    <button mat-button mat-raised-button color="primary" type="submit" [disabled]="!form.valid">
      {{ 'actions.send' | translate }}
    </button>
  </mat-dialog-actions>
</form>
